<template>
  <div>
    <SampleSearchForm
      ref="sampleSearchForm"
      :listForm="searchList"
      @handlerSearch="onSearch"
    />
    <div class="cml-button-group">
      <el-button size="mini" type="primary" @click="addBtn">新增</el-button>
      <el-button
        size="mini"
        type="primary"
        @click="enableBtn"
        :loading="enableBtnLoading"
        :disabled="selectData.length < 1"
        >启用</el-button
      >
      <el-button
        size="mini"
        type="primary"
        @click="disableBtn"
        :loading="disableBtnLoading"
        :disabled="selectData.length < 1"
        >停用</el-button
      >
      <el-button
        size="mini"
        type="primary"
        @click="deleteBtn"
        :loading="deleteBtnLoading"
        :disabled="selectData.length < 1"
        >删除</el-button
      >
      <el-button
        style="float: right"
        size="mini"
        type="primary"
        :loading="cleanCacheLoading"
        @click="cleanCache"
        >清除用户缓存</el-button
      >
      <el-button
        style="float: right"
        size="mini"
        type="primary"
        :loading="cleanSupplierCacheLoading"
        @click="cleanSupplierCache"
        >清除供应商缓存</el-button
      >
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <!-- 内外部用户 -->
      <template #customSlot="{ row }">
        <span>{{ row.customerId === '0' ? '内部' : '外部' }}</span>
      </template>
      <!-- 状态 -->
      <template #isEnableSlot="{ row }">
        <span>{{ row.isEnable === '1' ? '启用' : '停用' }}</span>
      </template>
      <!-- 修改 -->
      <template #updateSlot="{ row }">
        <el-button type="text" @click="updateBtn(row)">修改</el-button>
      </template>
    </CommonTable>

    <!-- 修改弹框 -->
    <el-dialog
      class="user-info"
      :title="state === 'add' ? '新增用户信息' : '修改用户信息'"
      :visible.sync="dialogVisible"
      width="500px"
      @close="dialogClose"
    >
      <el-form
        v-if="dialogVisible"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="135px"
      >
        <el-form-item label="归属客户" prop="customerId">
          <el-radio-group
            v-model="ruleForm.customerId"
            @change="customerChange"
            :disabled="state !== 'add'"
          >
            <el-radio label="0">内部账号</el-radio>
            <el-radio label="1">外部账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="登录账号" prop="account">
          <el-input
            :disabled="state === 'update'"
            v-model.trim="ruleForm.account"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录名称" prop="loginName">
          <el-input v-model.trim="ruleForm.loginName"></el-input>
        </el-form-item>
        <el-form-item label="用户角色" prop="userRole">
          <el-select v-model="ruleForm.userRole" multiple placeholder="请选择" clearable filterable>
            <el-option 
              v-for="item in userRoleList" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id" />
            <!-- <el-option label="采购" value="1"></el-option>
            <el-option label="企划" value="2"></el-option>
            <el-option label="管理员" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.customerId === '1' && state === 'add'"
          label="登录密码"
          prop="password"
        >
          <el-input v-model.trim="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.customerId === '1'"
          label="供应商名称"
          prop="supplierCode"
        >
          <SupplierSelect
            :selectDictData="supplierList"
            :value="ruleForm.supplierCode"
            @change-emit="supplierChange"
          />
        </el-form-item>
        <el-form-item label="手机" prop="mobile">
          <el-input v-model.trim="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="ruleForm.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import SupplierSelect from '@/components/SupplierSelect';
export default {
  name: 'user',
  components: { CommonTable, SampleSearchForm, SupplierSelect },
  props: {},
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '登录账号',
            prop: 'account',
            defaultValue: undefined,
          },
          {
            tag: 'el-input',
            label: '登录名称',
            prop: 'loginName',
            defaultValue: undefined,
          },
          {
            tag: 'el-input',
            label: '供应商名称',
            prop: 'supplierName',
            defaultValue: undefined,
          },
        ],
      },
      listForm: {},
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        { label: '登录账号', prop: 'account' },
        { label: '登录名称', prop: 'loginName' },
        {
          label: '归属客户',
          prop: 'customerId',
          slotColumn: true,
          slotName: 'customSlot',
        },
        { label: '供应商名称', prop: 'supplierName' },
        {
          label: '状态',
          prop: 'isEnable',
          slotColumn: true,
          slotName: 'isEnableSlot',
        },
        {
          label: '操作',
          prop: 'update',
          slotColumn: true,
          slotName: 'updateSlot',
        },
      ],
      tableDataTab: {},
      dialogVisible: false,
      saveLoading: false,
      selectData: [],
      supplierList: [],
      state: '',
      ruleForm: {
        id: '',
        account: '',
        loginName: '',
        password: '',
        customerId: '',
        supplierName: '',
        supplierCode: '',
        mobile: '',
        email: '',
        userRole: []
      },
      title: '用户信息',
      rules: {
        account: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
        ],
        loginName: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
        ],
        customerId: [
          { required: true, message: '请选择归属客户', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
        ],
        supplierCode: [
          { required: true, message: '请选择供应商', trigger: 'change' },
        ],
        userRole: [
          { required: true, message: '请选择用户角色', trigger: 'change' },
        ],
        // mobile: [
        //   {
        //     validator: function (rule, value, callback) {
        //       if (/^1[345678]\d{9}$/.test(value) == false) {
        //         callback(new Error('手机号格式错误'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        email: [
          { required: false, message: '请输入邮箱', trigger: 'blur' },
          // {
          //   validator: function (rule, value, callback) {
          //     if (
          //       /^\w{1,64}@[a-z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i.test(
          //         value,
          //       ) == false
          //     ) {
          //       callback(new Error('邮箱格式错误'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: 'blur',
          // },
        ],
      },
      cleanCacheLoading: false,
      cleanSupplierCacheLoading: false,
      enableBtnLoading: false,
      disableBtnLoading: false,
      deleteBtnLoading: false,
      userRoleList: []
    };
  },
  mounted() {
    this.getList();
    this.getSupplierList();
    this.getRoleList()
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    getSupplierList() {
      this.$http.setting
        .getAllSupplierList({})
        .then(result => {
          this.supplierList = result.data.map(item => {
            item.id = item.code;
            return item;
          });
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 角色下拉数据
    getRoleList() {
      this.$http.user.getRoleList().then(res => {
        this.userRoleList = res.data
      })
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.user
        .getUserList(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectData = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    addBtn() {
      this.state = 'add';
      this.dialogVisible = true;
    },
    updateBtn(row) {
      this.state = 'update';
      this.dialogVisible = true;
      this.$http.user
        .getUser(row.id)
        .then(result => {
          result.data.userRole = result.data.userRole.split(',')
          Object.keys(this.ruleForm).map(el => {
            this.ruleForm[el] = result.data[el];
          });
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    enableBtn() {
      if (this.selectData.some(item => item.isEnable === '1')) {
        this.$message.error('请选择【已停用】的数据进行操作');
        return;
      }
      this.operateBtn('enable');
    },
    disableBtn() {
      if (this.selectData.some(item => item.isEnable === '0')) {
        this.$message.error('请选择【已启用】的数据进行操作');
        return;
      }
      this.operateBtn('disable');
    },
    deleteBtn() {
      if (this.selectData.some(item => item.isEnable === '1')) {
        this.$message.error('请选择【已停用】的数据进行操作');
        return;
      }
      this.$confirm('此操作将删除所选用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.operateBtn('delete');
      });
    },
    operateBtn(val) {
      this[`${val}BtnLoading`] = true;
      this.$http.user[val](this.selectData.map(item => item.id))
        .then(result => {
          this.getList();
          this.$message.success(result.msg);
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this[`${val}BtnLoading`] = false;
        });
    },
    saveBtn() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url = '';
          let params = {
             ...this.ruleForm,
             userRole: this.ruleForm.userRole.join(',')
           };
          if (this.state === 'add') {
            url = 'createUser';
            delete params.id;
          } else {
            delete params.password;
            url = 'updateUser';
          }
          // 内部用户
          if (params.customerId === '0') {
            params.supplierName = '';
            params.supplierCode = '';
            params.isSrmUser = '0';
          } else {
            params.isSrmUser = '1';
          }
          this.saveLoading = true;
          this.$http.user[url](params)
            .then(() => {
              this.getList();
              this.dialogVisible = false;
            })
            .catch(err => {
              this.$message.error(err.msg);
            })
            .finally(() => {
              this.saveLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 清空用户缓存
    cleanCache() {
      this.$confirm('此操作将清空用户缓存, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.cleanCacheLoading = true;
        this.$http.user
          .cleanCache()
          .then(result => {
            this.getList();
            this.$message.success(result.msg);
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.cleanCacheLoading = false;
          });
      });
    },
    // 清空供应商缓存
    cleanSupplierCache() {
      this.$confirm('此操作将清空供应商缓存, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.cleanSupplierCacheLoading = true;
        this.$http.user
          .cleanSupplierCache()
          .then(result => {
            this.getList();
            this.$message.success(result.msg);
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.cleanSupplierCacheLoading = false;
          });
      });
    },
    customerChange(val) {
      this.rules.email[0].required = val === '0';
      this.$refs.ruleForm.clearValidate();
    },
    supplierChange(code, name) {
      this.ruleForm.supplierCode = code;
      this.ruleForm.supplierName = name;
    },
    dialogClose() {
      this.$refs.ruleForm.resetFields();
      Object.keys(this.ruleForm).map(el => {
        this.ruleForm[el] = '';
      });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    selectChange(arr) {
      this.selectData = arr;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .user-info {
  .el-input--mini {
    width: 250px !important;
  }
  .el-input--mini .el-input__inner {
    width: 250px !important;
    padding-right: 45px;
  }
}
</style>
